import styled from 'styled-components';
import { AllAssetsTable } from 'src/components';

export const CustomAllAssetsTable = styled(AllAssetsTable)`
  margin-top: 5.8rem;
  ${({ theme }) => theme.media.laptop`
      margin-top: 1.8rem;
  `};
`;
